import { StyleSheet, Dimensions } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const SCREEN_WIDTH = Dimensions.get('screen').width

const styles = StyleSheet.create({
  headerTitle: {
    color: Colors.white
  },
  paddingHorizontal20: {
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
  margin0: {
    margin: 0
  },
  displayFlex: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  carouselCardIcon: {
    resizeMode: 'contain',
    marginRight: 10
  },
  carouselCardTitle: {
    fontSize: Fonts.size.regularSmall,
    ...Fonts.type.bold,
  },
  carouselCardPhoneInfoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 19,
    marginBottom: 8
  },
  carouselPhoneTitle: {
    fontSize: Fonts.size.h3,
    ...Fonts.type.bold,
    marginRight: 10,
  },
  title: {
    fontSize: Fonts.size.h4,
    ...Fonts.type.bold,
    marginTop: 32,
    marginBottom: 16
  },
  detailsTitle: {
    fontSize: Fonts.size.input,
    ...Fonts.type.bold,
    marginBottom: 4
  },
  detailsContainer: {
    marginBottom: 16
  },
  fontSize18: {
    fontSize: Fonts.size.input
  },
  imageSize: {
    width: SCREEN_WIDTH * 0.898,
    margin: -23,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5
  },
  embassiesStyles: {
    marginHorizontal: -20,
    paddingBottom: 40
  },
  carouselCardPhoneCallPrice: {
    // color: 'rgba(102, 102, 102, 1)'
  }
})

export default styles
